/**
 * Het paneel "Hulp van Socrates" onder het argumentenformulier: de vier
 * knoppen, de melding, en de antwoorden met het nieuwste bovenaan. De
 * logica staat in hooks/useHulp.js.
 */
import React from 'react';
import { kleur } from '../../../theme/tokens';
import { basis } from '../stijlen';

export function HulpVanSocrates({ hulp }) {
  const knop = (soort, tekst) => (
    <button onClick={() => hulp.vraag(soort)} disabled={!!hulp.bezig} style={styles.hulpBtn}>
      {hulp.bezig === soort ? 'Even kijken…' : tekst}
    </button>
  );

  return (
    <div style={styles.hulpPaneel}>
      <h3 style={styles.hulpKop}>Hulp van Socrates</h3>
      <p style={styles.uitleg}>
        Socrates geeft je geen argumenten — die bedenk je zelf. Hij legt wel uit
        wat er is gezegd, en stelt vragen bij wat je hebt opgeschreven.
      </p>
      <div style={styles.hulpKnoppen}>
        {knop('verhelder', 'Leg uit wat er staat')}
        {knop('vereenvoudig', 'Zeg het korter')}
        {knop('hints', 'Geef me een tip')}
        <button onClick={hulp.vraagBronnen} disabled={!!hulp.bezig} style={styles.hulpBtn}>
          {hulp.bezig === 'bronnen' ? 'Even kijken…' : 'Welke bronnen?'}
        </button>
      </div>
      {hulp.melding && <p style={styles.hulpMelding}>{hulp.melding}</p>}

      {hulp.antwoorden.map((h, idx) => (
        <div key={idx} style={styles.hulpAntwoord}>
          <div style={styles.hulpLabel}>{h.label}</div>
          {h.overTekst && <div style={styles.hulpOver}>over: “{h.overTekst}”</div>}
          {h.soort === 'bronnen' ? <Bronnen bronnen={h.bronnen} /> : <p style={styles.hulpTekst}>{h.antwoord}</p>}
        </div>
      ))}
    </div>
  );
}

function Bronnen({ bronnen }) {
  if (bronnen.length === 0) return <p style={styles.hulpTekst}>Bij deze stelling zijn geen bronnen opgegeven.</p>;
  return (
    <>
      <p style={styles.hulpTekst}>
        Hier komt de kennis van de deelnemers uit. Je ziet alleen de titels —
        wat vind je zelf: is dit te vertrouwen?
      </p>
      <ul style={styles.bronnenLijst}>
        {bronnen.map((b, i) => (
          <li key={i} style={styles.bronRegel}>
            <span>{b.titel}</span>
            {b.kant && <span style={styles.bronKant}>{b.kant}</span>}
          </li>
        ))}
      </ul>
    </>
  );
}

export const hulpStijlen = {
  hulpKop: { margin: '0 0 6px', fontSize: '16px' },
  hulpTekst: { margin: 0, fontSize: '15px', lineHeight: 1.55, whiteSpace: 'pre-wrap' },
};

const styles = {
  ...basis,
  ...hulpStijlen,
  hulpPaneel: { background: kleur.vlakKoel, border: `1px solid ${kleur.lijn}`, borderRadius: '14px', padding: '16px', marginTop: '20px' },
  hulpKnoppen: { display: 'flex', flexWrap: 'wrap', gap: '8px' },
  hulpBtn: { padding: '10px 14px', border: `2px solid ${kleur.accent}`, background: 'white', color: kleur.accentTekst, borderRadius: '10px', cursor: 'pointer', fontSize: '14px', font: 'inherit' },
  hulpMelding: { color: kleur.amberTekst, background: kleur.amber, padding: '8px 10px', borderRadius: '8px', fontSize: '14px', margin: '10px 0 0' },
  hulpAntwoord: { background: 'white', border: `1px solid ${kleur.lijnLichter}`, borderRadius: '10px', padding: '12px 14px', marginTop: '12px' },
  hulpLabel: { fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.04em', color: kleur.groenZacht, fontWeight: 'bold', marginBottom: '4px' },
  hulpOver: { fontSize: '13px', color: kleur.tekstStil, fontStyle: 'italic', marginBottom: '6px' },
  bronnenLijst: { listStyle: 'none', margin: '10px 0 0', padding: 0, display: 'flex', flexDirection: 'column', gap: '6px' },
  bronRegel: { display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'baseline', fontSize: '14px' },
  bronKant: { fontSize: '12px', color: kleur.tekstGrijs, background: kleur.vlakBron, padding: '2px 8px', borderRadius: '10px' },
};
